<template>
    <div>
        <meta name="viewport" content="width=device-width,initial-scale=1.0">
        <div v-if="loading" style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 88vh;">
            <div style="display: flex; flex-direction: column; align-items: center;">
                <div style="display: block;">
                    <v-img :src="logo" :style="`width: ${$vuetify.breakpoint.smAndDown ? 30 : 17}vw;`"contain></v-img>
                </div>
                <div style="display: block; text-align: center; margin-top: 30px; width: 100%; ">
                    <v-progress-linear indeterminate color="primary" rounded class="mx-auto" style="width: 60%; height: 10px;"></v-progress-linear>
                </div>
            </div>
            <div style="display: block; position: fixed; bottom: 15px;">
                <small> Copyright &copy;  {{ new Date().getFullYear() }} Xera Clinic </small>
            </div>
        </div>

        <v-container fluid v-else>
            <v-row>
                <v-col cols="12">
                    <v-card height="99" style="background-color: #7053F7 !important; color: white;" class="px-3">
                        <div class="float-start pt-2" style="font-size: 18pt;">Xera Clinic</div>
                        <div class="float-end pt-2 pe-2">
                            <img :src="logo_bw" width="40"/>
                        </div>
                        <div style="clear: both !important;">
                            <v-divider style="clear: both;"></v-divider>
                            <div style="width: 100%; font-size: 13pt; margin-top: 6px;" class="text-center">To show your test results ...</div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>


            <v-row style="clear: both;">
                <!-- <v-col cols="12" class="py-2" v-if="patients.length > 1">
                    <v-select :hide-details="true" outlined dense label="Patient" :items="patients" class="centered-input input-15" item-text="full_name" item-value="patient_id" v-model="patient_id"></v-select>
                </v-col> -->
                <v-col cols="12" md="12" lg="4" xl="4" class="pb-1" v-for="sample in patient_samples.filter(f => f.patient_id == patient_id)" :key="'s' + sample.lab_sample_id">
                    <v-card class="px-3 py-2" style="background-color: #f9f0ff; color: #7053F7;" @click="openSample(sample.lab_sample_uuid)">
                        <div class="text-center">
                            <div style="font-size: 11pt; font-weight: 600; ">{{ moment(sample.lab_sample_date).format('DD-MM-YYYY') }}</div>
                            <div style="font-size: 13pt; color: #262626; margin-top: 4px;">{{ sample.patient_full_name }}</div>
                        </div>
                        <v-divider style="clear: both !important; margin-top: 10px;" class="mb-2"></v-divider>
                        <div class="text-center" style="clear: both; margin-top: 10px;">
                            <div style="font-size: 16pt;" :class="{'xc-noto-sans-font': !isEnglishText(sample.lab_name)}">{{ sample.lab_name }}</div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
    name: "PatientSamples",
    data() {
        return {
            moment,
            loading: false,
            logo_bw: require('../../assets/bw-logo.svg'),
            logo: require('../../assets/main-logo.svg'),
            patient_samples: [],
            patients: [],
            patient_id: null
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            const patient_uuid = this.$route.params.patient_uuid
            const lab_uuid = this.$route.params.lab_uuid
            const from_sample_uuid = this.$route.params.from_sample_uuid
            this.loading = true
            axios.get('lab_samples/getSamplesByUUID/' + patient_uuid + '/' + lab_uuid + '/' + from_sample_uuid).then(r => {
                this.patient_samples = r.data.lab_samples
                this.patients = r.data.patients
                this.patient_id = r.data.patient.patient_id
                this.loading = false
            }).catch(e => {
                console.log(e)
            })
        },
        openSample(uuid) {
            window.open('https://labresult.xeraclinic.com/lab_samples/' + uuid, '_blank')
        }
    },
}
</script>

<style scoped>
@font-face {
    font-family: 'xc-noto-sans';
    src: url('../../assets/Fonts/NotoSansArabic-SemiCondensed.ttf');
}

.xc-noto-sans-font {
    font-family: xc-noto-sans;
}
</style>